<div class="spinner" *ngIf="showSpinner">
  <mat-spinner></mat-spinner>
</div>

<div class="page-container">
  <div class="titles-holder">
    <div class="merck-font-title">
      In-depth status update by country and solution
    </div>
  </div>

  <app-mecs-in-depth-filter
    (filter)="getFilterData($event)"
  ></app-mecs-in-depth-filter>
  <div class="information-holder">
    <img class="info-icon" src="assets/images/info_purple_icon.png" alt="" />
    <div>Click the map to see more details.</div>
  </div>

  <div class="map">
    <app-mecs-map
      [config]="mapConfig"
      (clickedRegion)="onRegionClick($event)"
    ></app-mecs-map>
  </div>

  <div class="country-solution-container">
    <div class="data-container">
      <div class="title-arrow">
        <div class="title-holder">
          <p class="title">Countries</p>
          <div class="search-holder">
            <input
              type="text"
              class="search"
              placeholder="Search"
              (ngModelChange)="onInputChange($event)"
              [(ngModel)]="countrySearchText"
              (keydown.enter)="onSearch()"
            />
            <div class="search-button" (click)="onSearch()">
              <img
                class="search-icon"
                src="assets/images/search-icon.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <svg
          class="arrow"
          [ngClass]="{ rotate: isFilterContainerOpen }"
          (click)="onClick()"
          width="29"
          height="29"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="14.5"
            cy="14.5"
            r="14.5"
            transform="rotate(-180 14.5 14.5)"
            fill="#503291"
          />
          <path
            d="M20.2119 13.1819L14.4998 18.4546L8.78767 13.1819"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <div class="country-container" *ngIf="!isFilterContainerOpen">
        <empty-state *ngIf="filteredCountries.length === 0"></empty-state>
        <div
          class="country-holder"
          *ngFor="let country of filteredCountries"
          (click)="onCountryClick(country.id)"
          [ngClass]="{
            'active-country': selectedCountries.includes(country.id)
          }"
        >
          <div class="flag">
            <img
              class="country-flag"
              [src]="'assets/flags/' + country?.id + '.svg'"
              alt=""
            />
            <div class="country-name">{{ country?.name }}</div>
          </div>
          <div class="action-holder" (click)="onCountryClick(country.id); $event.stopPropagation()">
            <img
              [src]="
                selectedCountries.includes(country.id)
                  ? 'assets/images/XBUTTOn.png'
                  : 'assets/images/ARROW.png'
              "
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="country-data-container" *ngFor="let item of selectedCountries">
    <div class="data-container">
      <div class="title-arrow">
        <div class="title-holder-country-name">
          <p class="title">Country</p>
          <div>></div>
          <p>{{ countryDataMap[item]?.country }}</p>
        </div>

        <svg
          class="arrow"
          [ngClass]="{ rotate: expandedCountryData[item] }"
          (click)="toggleExpand(item)"
          width="29"
          height="29"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="14.5"
            cy="14.5"
            r="14.5"
            transform="rotate(-180 14.5 14.5)"
            fill="#503291"
          />
          <path
            d="M20.2119 13.1819L14.4998 18.4546L8.78767 13.1819"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <div *ngIf="expandedCountryData[item]" class="country-name-holder">
        <div class="country-name-container">
          <div class="flag">
            <img
              class="country-flag"
              [src]="'assets/flags/' + item + '.svg'"
              alt=""
            />
            <div class="country-name-region">
              <div class="name-title">
                {{ countryDataMap[item]?.country }}
              </div>
              <div class="region-title">
                {{ countryDataMap[item]?.region }}
              </div>
            </div>
          </div>

          <div class="key-contact-people">
            <div class="key-contact-title">Key contact people</div>

            <div
              class="key-contact-item"
              *ngIf="countryDataMap[item].contactDetails.length === 0"
            >
              <div class="contact-item">No contact available</div>
            </div>

            <div
              class="key-contact-item"
              *ngFor="let contact of countryDataMap[item]?.contactDetails"
            >
              <div class="contact-item">
                <img src="assets/images/PROFILE.png" alt="" />
                <div>{{ contact.contactName }}</div>
              </div>
            </div>
          </div>

          <div class="key-contact-people">
            <div class="key-contact-title">Emails</div>

            <div
              class="key-contact-item"
              *ngIf="countryDataMap[item].contactDetails.length === 0"
            >
              <div class="contact-item">No contact details available</div>
            </div>

            <div
              class="key-contact-item"
              *ngFor="let contact of countryDataMap[item]?.contactDetails"
            >
              <div class="contact-item">
                <a href="mailto:{{ contact.contactEmail }}">{{
                  contact.contactEmail
                }}</a>
              </div>
            </div>
          </div>

          <div class="key-contact-people">
            <div class="key-contact-title">Contact Date</div>

            <div
              class="key-contact-item"
              *ngIf="countryDataMap[item].contactDetails.length === 0"
            >
              <div class="contact-item">No contact date available</div>
            </div>

            <div
              class="key-contact-item"
              *ngIf="countryDataMap[item].products.length != 0"
            >
              <div class="contact-item">
                <div>
                  {{ getEarliestContactDate(item) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="country-data-holder" *ngIf="expandedCountryData[item]">
        <div class="country-data-title">Products in scope</div>

        <div class="products-holder">
          <empty-state
            *ngIf="countryDataMap[item].products.length === 0"
          ></empty-state>
          <div
            class="products-container"
            *ngFor="let item of countryDataMap[item].products"
          >
            <div class="products-title-holder" (click)="toggleProject(item.id)">
              <div class="left-side-product-holder">
                <div class="product-title-box">
                  <div class="product-color-box"></div>

                  <div class="product-name">
                    {{ item?.name }}
                  </div>
                </div>

                <div class="project-manager-name" *ngIf="item?.projectManagerName">
                  <img src="assets/images/manager-icon.png" alt="" />
                  <div class="name">
                    {{ item?.projectManagerName }}
                  </div>
                </div>

                <div class="project-manager-name">
                  <img src="assets/images/calendar-icon.png" alt="" />
                  <div class="name">
                    {{
                      item.launchDate
                        ? (item.launchDate | date : "dd.MM.yyyy")
                        : "TBD"
                    }}
                  </div>
                </div>
              </div>

              <div
                class="project-collapse-button"
                (click)="toggleProject(item.id); $event.stopPropagation()"
              >
                <img
                  [ngClass]="{ rotate: expandedProjects[item.id] }"
                  src="assets/images/collapse-in-depth.png"
                  alt="Toggle"
                />
              </div>
            </div>

            <!-- Expanded Section -->
            <div *ngIf="expandedProjects[item.id]" class="project-expanded-box">
              <div class="milestones-title">Milestones</div>
              <div class="milestones-data-container">
                <div class="milestones-holder">
                  <div class="milestone">
                    <div class="milestone-title-holder">
                      <img src="assets/images/Frame 1.png" alt="" />
                      <div>Contacted through</div>
                    </div>

                    <div class="milestone-data-holder">
                      <div
                        *ngFor="let method of item.contactedThrough?.split(',')"
                        class="contacted-through-data"
                      >
                        {{ method.trim() ? method.trim() : "No data" }}
                      </div>
                    </div>
                  </div>

                  <div class="milestone">
                    <div class="milestone-title-holder">
                      <img src="assets/images/Frame 2.png" alt="" />
                      <div>Materials delivered</div>
                    </div>

                    <div class="milestone-data-holder-information blue">
                      {{ item.materialsDelivered }}
                    </div>
                  </div>

                  <div class="milestone">
                    <div class="milestone-title-holder">
                      <img src="assets/images/Frame 3.png" alt="" />
                      <div>Training completed</div>
                    </div>

                    <div
                      class="milestone-data-holder-information"
                      [ngClass]="{
                        green: item.trainingCompleted === 'Yes',
                        red:
                          item.trainingCompleted === 'No' ||
                          item.trainingCompleted === '',
                        orange: item.trainingCompleted === 'OnHold'
                      }"
                    >
                      {{
                        item.trainingCompleted ? item.trainingCompleted : "No"
                      }}
                    </div>
                  </div>

                  <div class="milestone">
                    <div class="milestone-title-holder">
                      <img src="assets/images/Frame 4.png" alt="" />
                      <div>Regulatory assessment completed</div>
                    </div>

                    <div
                      class="milestone-data-holder-information"
                      [ngClass]="{
                        green: item.regularityCompleted === 'Yes',
                        red:
                          item.regularityCompleted === 'No' ||
                          item.regularityCompleted === '',
                        orange: item.regularityCompleted === 'OnHold'
                      }"
                    >
                      {{
                        item.regularityCompleted
                          ? item.regularityCompleted
                          : "No"
                      }}
                    </div>
                  </div>

                  <div class="milestone">
                    <div class="milestone-title-holder">
                      <img src="assets/images/Frame 5.png" alt="" />
                      <div>MLR approval completed</div>
                    </div>

                    <div
                      class="milestone-data-holder-information"
                      [ngClass]="{
                        green: item.mlrCompleted === 'Yes',
                        red:
                          item.mlrCompleted === 'No' ||
                          item.mlrCompleted === '',
                        orange: item.mlrCompleted === 'OnHold'
                      }"
                    >
                      {{ item.mlrCompleted ? item.mlrCompleted : "No" }}
                    </div>
                  </div>
                </div>
                <div class="milestones-holder">
                  <div class="milestone">
                    <div class="milestone-title-holder">
                      <img src="assets/images/Frame 6.png" alt="" />
                      <div>Translation/localization completed</div>
                    </div>

                    <div
                      class="milestone-data-holder-information"
                      [ngClass]="{
                        'green': item.translationCompleted === 'Yes',
                        'red': item.translationCompleted === 'No' || item.translationCompleted === '',
                        'orange': item.translationCompleted === 'OnHold',
                      }"
                    >
                      {{
                        item.translationCompleted
                          ? item.translationCompleted
                          : "No"
                      }}
                    </div>
                  </div>

                  <div class="milestone">
                    <div class="milestone-title-holder">
                      <img src="assets/images/Frame 7.png" alt="" />
                      <div>Tech setup completed</div>
                    </div>

                    <div
                      class="milestone-data-holder-information"
                      [ngClass]="{
                        'green': item.techSetupCompleted === 'Yes',
                        'red': item.techSetupCompleted === 'No' || item.techSetupCompleted === '',
                        'orange': item.techSetupCompleted === 'OnHold',
                      }"
                    >
                      {{
                        item.techSetupCompleted ? item.techSetupCompleted : "No"
                      }}
                    </div>
                  </div>

                  <div class="milestone">
                    <div class="milestone-title-holder">
                      <img src="assets/images/Frame 8.png" alt="" />
                      <div>Field training completed</div>
                    </div>

                    <div
                      class="milestone-data-holder-information"
                      [ngClass]="{
                        'green': item.fieldTrainingCompleted === 'Yes',
                        'red': item.fieldTrainingCompleted === 'No' || item.fieldTrainingCompleted === '',
                        'orange': item.fieldTrainingCompleted === 'OnHold',
                      }"
                    >
                      {{
                        item.fieldTrainingCompleted
                          ? item.fieldTrainingCompleted
                          : "No"
                      }}
                    </div>
                  </div>

                  <div class="milestone">
                    <div class="milestone-title-holder">
                      <img src="assets/images/Frame 9.png" alt="" />
                      <div>Launch Date</div>
                    </div>

                    <div class="milestone-data-holder-information blue">
                      {{
                        item.launchDate
                          ? (item.launchDate | date : "dd.MM.yyyy")
                          : "TBD"
                      }}
                    </div>
                  </div>

                  <div class="milestone">
                    <div class="milestone-title-holder">
                      <img src="assets/images/Frame 9-1.png" alt="" />
                      <div>Notes</div>
                    </div>

                    <div class="milestone-data-holder-information">
                      <div
                        class="action-holder"
                        (click)="onNotesClick(item.id)"
                      >
                        <img
                          [src]="
                            selectedCountryNotes.includes(item.id)
                              ? 'assets/images/XBUTTOn.png'
                              : 'assets/images/ARROW.png'
                          "
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="milestone-notes" *ngIf="selectedCountryNotes.includes(item.id)">
                <div class="notes-title">Notes</div>

                <div class="notes-content">
                  {{ item.notes ? item.notes : "No notes available" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
